var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMalibu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 62.1393 119.888 64.2524 119.67 66.3339L63.9754 60.4906C63.9904 60.3468 64 60.1841 64 60C64 59.8159 63.9904 59.6532 63.9754 59.5094L119.67 53.6661C119.888 55.7476 120 57.8607 120 60Z",
    fill: "url(#paint0_radial_3658_56599)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8446 61.1598L117.561 76.9895C116.353 81.0883 114.719 85.0046 112.711 88.6872L63.5472 61.8738C63.6762 61.6373 63.7741 61.3992 63.8446 61.1598Z",
    fill: "url(#paint1_radial_3658_56599)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1342 62.4888L106.669 97.7131C104.006 101.003 101.003 104.006 97.7131 106.669L62.4888 63.1342C62.7252 62.9429 62.9429 62.7252 63.1342 62.4888Z",
    fill: "url(#paint2_radial_3658_56599)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8738 63.5472L88.6872 112.711C85.0046 114.719 81.0883 116.353 76.9895 117.561L61.1598 63.8446C61.3992 63.7741 61.6373 63.6762 61.8738 63.5472Z",
    fill: "url(#paint3_radial_3658_56599)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4906 63.9754L66.3339 119.67C64.2524 119.888 62.1393 120 60 120C57.8607 120 55.7476 119.888 53.6661 119.67L59.5094 63.9754C59.6532 63.9904 59.8159 64 60 64C60.1841 64 60.3468 63.9904 60.4906 63.9754Z",
    fill: "url(#paint4_radial_3658_56599)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8402 63.8446L43.0105 117.561C38.9117 116.353 34.9954 114.719 31.3128 112.711L58.1262 63.5472C58.3627 63.6762 58.6008 63.7741 58.8402 63.8446Z",
    fill: "url(#paint5_radial_3658_56599)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5112 63.1342L22.2869 106.669C18.9966 104.006 15.9935 101.003 13.3313 97.7131L56.8658 62.4888C57.0571 62.7252 57.2748 62.9429 57.5112 63.1342Z",
    fill: "url(#paint6_radial_3658_56599)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4528 61.8738L7.28938 88.6872C5.28093 85.0046 3.64715 81.0883 2.43926 76.9895L56.1554 61.1598C56.2259 61.3992 56.3238 61.6373 56.4528 61.8738Z",
    fill: "url(#paint7_radial_3658_56599)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0246 60.4906L0.330341 66.3339C0.11196 64.2524 0 62.1393 0 60C0 57.8607 0.111961 55.7476 0.330342 53.6661L56.0246 59.5094C56.0096 59.6532 56 59.8159 56 60C56 60.1841 56.0096 60.3468 56.0246 60.4906Z",
    fill: "url(#paint8_radial_3658_56599)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1554 58.8402L2.43926 43.0105C3.64715 38.9117 5.28093 34.9954 7.28938 31.3128L56.4528 58.1262C56.3238 58.3627 56.2259 58.6008 56.1554 58.8402Z",
    fill: "url(#paint9_radial_3658_56599)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8658 57.5112L13.3313 22.2869C15.9935 18.9966 18.9966 15.9935 22.2869 13.3313L57.5112 56.8658C57.2748 57.0571 57.0571 57.2748 56.8658 57.5112Z",
    fill: "url(#paint10_radial_3658_56599)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1262 56.4528L31.3128 7.28938C34.9954 5.28093 38.9117 3.64715 43.0105 2.43926L58.8402 56.1554C58.6008 56.2259 58.3627 56.3238 58.1262 56.4528Z",
    fill: "url(#paint11_radial_3658_56599)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5094 56.0246L53.6661 0.330341C55.7476 0.11196 57.8607 0 60 0C62.1393 0 64.2524 0.111961 66.3339 0.330342L60.4906 56.0246C60.3468 56.0096 60.1841 56 60 56C59.8159 56 59.6532 56.0096 59.5094 56.0246Z",
    fill: "url(#paint12_radial_3658_56599)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1598 56.1554L76.9895 2.43926C81.0883 3.64715 85.0046 5.28093 88.6872 7.28938L61.8738 56.4528C61.6373 56.3238 61.3992 56.2259 61.1598 56.1554Z",
    fill: "url(#paint13_radial_3658_56599)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4888 56.8658L97.7131 13.3313C101.003 15.9935 104.006 18.9966 106.669 22.2869L63.1342 57.5112C62.9429 57.2748 62.7252 57.0571 62.4888 56.8658Z",
    fill: "url(#paint14_radial_3658_56599)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5472 58.1262L112.711 31.3128C114.719 34.9954 116.353 38.9117 117.561 43.0105L63.8446 58.8402C63.7741 58.6008 63.6762 58.3627 63.5472 58.1262Z",
    fill: "url(#paint15_radial_3658_56599)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3658_56599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60 60) rotate(90) scale(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalibu);
export default __webpack_public_path__ + "static/media/malibu.2a3b31279d39c8c3e167af78806feda7.svg";
export { ForwardRef as ReactComponent };